module.exports = __webpack_public_path__ + "img/9_18.4550ba5e.png";